import React from 'react'
import { Create } from 'react-admin'

import CompetitionsForm from './form'

export const ProceduresCreate = (props) => (
  <Create {...props}>
    <CompetitionsForm {...props} />
  </Create>
)

export default ProceduresCreate
